import { render, staticRenderFns } from "./DocSigningField.vue?vue&type=template&id=012048fd&scoped=true"
import script from "./DocSigningField.vue?vue&type=script&lang=js"
export * from "./DocSigningField.vue?vue&type=script&lang=js"
import style0 from "./DocSigningField.vue?vue&type=style&index=0&id=012048fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012048fd",
  null
  
)

export default component.exports